<template>
  <div>
    <!-- 轮播图-->
    <div class="w100 cpfa">
      <div class="flexslider">
        <ul class="slides">
          <div
            class="lunBotu"
            :style="{ background: 'url(' + require('@/assets/images/joinus/joinus_bg2.png') + ')'}"
          >
            <div class="container">
              <div class="ban2 float fon-fam">
                <h2>加入大晟极，实现你的理想</h2>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>

    <!-- <banner :bannerImgs="bannerImgs">
      <template v-slot:context>
        <h2>加入大晟极，实现你的理想</h2>
      </template>
    </banner>-->

    <div class="intro">
      <p v-for="(item, index) in introduc" :key="index">{{item}}</p>
    </div>
    <!-- 职位发布 -->
    <div class="w100">
      <ul class="tab clearfix">
        <li v-bind:class="{ active: devIsActive }" @click="activeDep">产品开发岗</li>
        <li v-bind:class="{ active: reseachIsActive }" @click="activeRes">算法研发岗</li>
      </ul>
    </div>
    <Develop v-show="devIsActive"></Develop>
    <Research v-show="reseachIsActive"></Research>
    <div class="footblack" />
  </div>
</template>
<script>
import Develop from './develop.vue'
import Research from './research.vue'
// import Banner from '../../layout/Banner'
export default {
  data () {
    return {
      devIsActive: true,
      reseachIsActive: false,
      introduc: [
        '武汉大晟极科技有限公司（以下简称大晟极）成立于2017年6月，致力于声纹识别与语音智能技术研发，并结合视觉智能及大数据技术开发，是身份识别与音频大数据领域解决方案提供商。大晟极的技术发端于国防、公共安全相关语音智能应用，发展于民用身份识别安全应用领域，因此打造一家军民融合、人工智能领域的高科技企业，构建更加安全和便利的社会，是大晟极创立的初心。',
        '目前大晟极已开发出业界领先的声纹识别、智能音频处理与分析、声学拾音器产品系列，可广泛应用于国防、公共安全、智能安防、金融服务、移动互联网和智能物联网行业。',
        '海阔凭鱼跃，天高任鸟飞。大晟极热忱欢迎有志为国防与公共安全做出贡献，有志在人工智能与物联网应用领域做出一番事业的青年才俊加入。大晟极能给予的是无限广阔的事业平台、有竞争力的薪金和优秀骨干员工股权激励。'
      ]
    }
  },
  methods: {
    activeDep () {
      console.log('sdasd')
      this.devIsActive = true
      this.reseachIsActive = false
    },
    activeRes () {
      console.log('assadas')
      this.devIsActive = false
      this.reseachIsActive = true
    }
  },
  updated () {
    let scro = this.position
    if (scro == null) scro = 0
    document.documentElement.scrollTo = scro
  },
  components: {
    Develop,
    Research
    // Banner
  }
}
</script>
<style scoped>
.flexslider {
  position: relative;
  height: 584px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.lunBotu {
  margin-top: 4px;
  z-index: 1;
  background-size: 100% 100%;
  height: 587px;
}
.footblack {
  height: 85px;
  width: 100%;
  background: white;
}
.container .float {
  float: none;
  margin: 0 auto;
  width: 70%;
  margin-top: 75px;
}
.cpfa .ban2 h2 {
  text-align: center;
  margin-bottom: 46px;
}
.intro {
  margin: 0 auto;
  width: 1026px;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  margin-top: 50px;
  padding-bottom: 30px;
  margin-bottom: 35px;
}
.intro p {
  text-align: left;
  text-indent: 2em;
  font-size: 18px;
  line-height: 32px;
  font-weight: normal;
  color: rgba(102, 102, 102, 1);
}
.tab {
    width: 779px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutus/joinus/joinus.vue